import { COUNTRY, COUNTRY_CONFIG_WITH_LANG, LANGUAGE } from "@type/index";

type CurrencyFormatType = {
  separator: string;
  decimalSymbol: string;
  currencyCodeSpacing: boolean;
  scale: number;
};

const SPLIT_AMOUNT_AND_SIGN = /([^\d+]?)(\d+)/;

const currencyFormat: COUNTRY_CONFIG_WITH_LANG<CurrencyFormatType> = {
  [COUNTRY.AU]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: false,
      scale: 2
    }
  },
  [COUNTRY.CA]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    },
    [LANGUAGE.FR]: {
      separator: " ",
      decimalSymbol: ",",
      currencyCodeSpacing: true,
      scale: 2
    }
  },
  [COUNTRY.ID]: {
    [LANGUAGE.EN]: {
      separator: ".",
      decimalSymbol: ",",
      currencyCodeSpacing: false,
      scale: 0
    },
    [LANGUAGE.ID]: {
      separator: ".",
      decimalSymbol: ",",
      currencyCodeSpacing: false,
      scale: 0
    }
  },
  [COUNTRY.IN]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    }
  },
  [COUNTRY.MY]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    }
  },
  [COUNTRY.PH]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    }
  },
  [COUNTRY.SG]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: false,
      scale: 2
    }
  },
  [COUNTRY.TH]: {
    [LANGUAGE.EN]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    },
    [LANGUAGE.TH]: {
      separator: ",",
      decimalSymbol: ".",
      currencyCodeSpacing: true,
      scale: 2
    }
  },
  [COUNTRY.VN]: {
    [LANGUAGE.EN]: {
      separator: ".",
      decimalSymbol: ",",
      currencyCodeSpacing: true,
      scale: 0
    },
    [LANGUAGE.VI]: {
      separator: ".",
      decimalSymbol: ",",
      currencyCodeSpacing: true,
      scale: 0
    }
  }
};

export class CurrencyFormatter {
  country: COUNTRY;
  language: LANGUAGE;
  constructor(country: COUNTRY, language: LANGUAGE) {
    this.country = country;
    this.language = language;
  }

  // This function inserts a given separator to value
  static addSeparator(value: string, separator: string, by: number): string {
    return value.replace(/./g, (char, index, all) =>
      index && (all.length - index) % by === 0 ? separator + char : char
    );
  }

  formatInteger(integer: string) {
    // return CurrencyFormatter.addSeparator(integer, this.seperatorSymbol(), 3);
    // Split sign and integer
    const [, sign = "", digit = ""] =
      integer.match(SPLIT_AMOUNT_AND_SIGN) || [];
    const formattedInteger = CurrencyFormatter.addSeparator(
      digit,
      currencyFormat[this.country][this.language]?.separator || "",
      3
    );
    // Append sign after formatting the integer
    return `${sign}${formattedInteger}`;
  }

  // Return proper formatted currency value
  // format(value: number | string)
  format(value: any): string {
    const parsedPrice = Number.parseFloat(value).toFixed(
      currencyFormat[this.country][this.language]?.scale
    );
    const [integer, decimal] = parsedPrice.split(".");
    const formattedInteger = this.formatInteger(integer);
    const symbol = currencyFormat[this.country][this.language]?.decimalSymbol;
    const formattedCurrency = decimal
      ? `${formattedInteger}${symbol}${decimal}`
      : formattedInteger;
    return formattedCurrency;
  }
}
